import { Routes } from '@angular/router';
import { protectedOnlyGuard } from './core/auth/auth.guard';
import { publicOnlyGuard } from './core/auth/public-only.guard';
import { ErrorComponent } from './pages/error/error.component';
import { protectedRoutes } from './routes/protected.routes';
import { publicRoutes } from './routes/public.routes';
import { ProtectedLayoutComponent } from './shared/components/layout/protected-layout/protected-layout.component';
import { PublicLayoutComponent } from './shared/components/layout/public-layout/public-layout.component';

export const APP_ROUTES: Routes = [
	{
		path: 'error',
		component: ErrorComponent,
	},
	{
		path: '',
		component: PublicLayoutComponent,
		canMatch: [publicOnlyGuard],
		children: publicRoutes,
	},
	{
		path: '',
		component: ProtectedLayoutComponent,
		canMatch: [protectedOnlyGuard],
		children: protectedRoutes,
	},
	{ path: '**', redirectTo: '/error' },
];
